<template>
    <div>
        <v-toolbar flat color="#ecf0f3bd">
            <v-text-field
                style="flex: initial; width: 175px;"
                v-model="dateRangeText"
                label="Date range"
                readonly
                hide-details
                single-line
                @click="pickerDialog = true"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-menu>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on">
                        Report
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="exportToReport()">
                        <v-list-item-title>Year 2020</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToReport2021()">
                        <v-list-item-title>Year 2021</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToReport2022()">
                        <v-list-item-title>Year 2022</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToReport2023()">
                        <v-list-item-title>Year 2023</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn text @click="exportToExcel()">
                <v-icon left>mdi-download</v-icon>Export
            </v-btn>
        </v-toolbar>
        <v-container>
            <v-row>
                <v-col cols="4">
                    <v-card>
                        <v-card-title>Sampling Size</v-card-title>
                        <v-card-text>
                            <line-chart
                                :height="null"
                                :width="null"
                                :data="stats.total.data"
                                :labels="stats.total.labels"
                            ></line-chart>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card>
                        <v-card-title>Satisfaction Rate</v-card-title>
                        <v-card-text>
                            <pie-chart
                                :height="null"
                                :width="null"
                                :data="stats.satisfaction.data"
                                :labels="stats.satisfaction.labels"
                            ></pie-chart>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card>
                        <v-card-title>Average Score</v-card-title>
                        <v-card-text>
                            <bar-chart
                                :height="null"
                                :width="null"
                                :data="stats.monthly.data"
                                :labels="stats.monthly.labels"
                            ></bar-chart>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            Rating records
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :items-per-page="10"
                            :loading="loading"
                            :options.sync="tableOptions"
                            :server-items-length="totalItems"
                            :sort-by="defaultOrdering.column"
                            :sort-desc="defaultOrdering.descending"
                            multi-sort
                        >
                            <template v-slot:item="row">
                                <tr class="tm-pointer">
                                    <td>{{ row.item.location.name }}</td>
                                    <td>
                                        {{ row.item.location.category.name }}
                                    </td>
                                    <td>
                                        {{ row.item.device.name }}
                                    </td>
                                    <td>{{ row.item.score }}</td>
                                    <td>{{ row.item.comment ? row.item.comment : ' -- ' }}</td>
                                    <td>
                                        {{
                                            $moment(row.item.created_at).format(
                                                "DD-MM-YYYY HH:mm:ss"
                                            )
                                        }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="pickerDialog" persistent max-width="290">
            <v-date-picker v-model="dates" range multiple show-current>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="
                        pickerDialog = false;
                        refreshListOfItems();
                    "
                    >Update</v-btn
                >
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import BarChart from "@/components/BarChart";
import PieChart from "@/components/PieChart";
import LineChart from "@/components/LineChart";
var FileSaver = require("file-saver");

export default {
    name: "Feedback",
    data() {
        return {
            modelPath: "feedbacks",
            loading: false,
            items: [],
            dates: [
                this.$moment().subtract(1, "years").format("YYYY-MM-DD"),
                this.$moment().format("YYYY-MM-DD"),
            ],
            tableOptions: {},
            totalItems: 0,
            headers: [
                {
                    text: "Location",
                    value: "location__name",
                },
                {
                    text: "Category",
                    value: "location__category__name",
                },
                {
                    text: "Device",
                    value: "device__name",
                },
                {
                    text: "Rating",
                    value: "score",
                },
                {
                    text: "Comments",
                    value: "comment",
                },
                {
                    text: "Received At",
                    value: "created_at",
                },
            ],
            defaultOrdering: {
                column: ["created_at"],
                descending: [true],
            },
            pickerDialog: false,
            stats: {
                satisfaction: {
                    data: [],
                    labels: [],
                },
                monthly: {
                    data: [],
                    labels: [],
                },
                total: {
                    data: [],
                    labels: [],
                },
            },
        };
    },
    components: {
        BarChart,
        PieChart,
        LineChart,
    },
    computed: {
        dateRangeText() {
            return this.dates.sort().join(" - ");
        },
        filterStartDate() {
            return this.$moment(this.dates[0]).format("YYYY-MM-DDTHH:mm:ss");
        },
        filterEndDate() {
            return this.$moment(this.dates[1])
                .add(1, "day")
                .format("YYYY-MM-DDTHH:mm:ss");
        },
        filterStartDateExact() {
            return this.$moment(this.dates[0]).format("YYYY-MM-DD");
        },
        filterEndDateExact() {
            return this.$moment(this.dates[1]).format("YYYY-MM-DD");
        },
        ordering() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
            let ordering = "";
            sortBy.forEach((val, index, arr) => {
                ordering += ordering ? "," : "";
                ordering += (sortDesc[index] ? "-" : "") + val;
            });
            return ordering;
        },
    },
    watch: {
        tableOptions: {
            handler() {
                this.getListOfItems().then((data) => {
                    this.items = data.items;
                    this.totalItems = data.total;
                    this.loading = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.getListOfItems().then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
            this.loading = false;
        });
        this.getListOfCategories().then((data) => {
            this.categories = data.items;
            this.loading = false;
        });
        this.getStatsOfSatisfaction().then((data) => {
            this.stats.satisfaction.data = data.data;
            this.stats.satisfaction.labels = data.labels;
        });
        this.getStatsOfMonthlyAverage().then((data) => {
            this.stats.monthly.data = data.score;
            this.stats.monthly.labels = data.labels;

            this.stats.total.data = data.total;
            this.stats.total.labels = data.labels;
        });
    },
    methods: {
        getListOfItems: function () {
            return new Promise((resolve) => {
                const {
                    sortBy,
                    sortDesc,
                    page,
                    itemsPerPage,
                } = this.tableOptions;
                this.loading = true;

                this.$http({
                    method: "get",
                    url: `/${this.modelPath}`,
                    params: {
                        page: page,
                        itemsPerPage: itemsPerPage,
                        created_at__gte: this.filterStartDate,
                        created_at__lt: this.filterEndDate,
                        ordering: this.ordering,
                    },
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        const total = response.data.count;
                        resolve({
                            items,
                            total,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        getListOfCategories: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/categories`,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        getStatsOfSatisfaction: function () {
            return new Promise((resolve) => {
                this.$http({
                    url: `/stats/feedback`,
                    method: "GET",
                    params: {
                        type: "satisfaction",
                        start_date: this.filterStartDateExact,
                        end_date: this.filterEndDateExact,
                    },
                }).then((response) => {
                    let data = Object.values(response.data);
                    let labels = Object.keys(response.data);
                    resolve({
                        data,
                        labels,
                    });
                });
            });
        },
        getStatsOfMonthlyAverage: function () {
            return new Promise((resolve) => {
                this.$http({
                    url: `/stats/feedback`,
                    method: "GET",
                    params: {
                        type: "monthly_new",
                        start_date: this.filterStartDateExact,
                        end_date: this.filterEndDateExact,
                    },
                }).then((response) => {
                    let score = response.data.map((a) => a.average_score);
                    let total = response.data.map((a) => a.total);
                    let labels = response.data.map((a) => a.month);
                    resolve({
                        score,
                        total,
                        labels,
                    });
                });
            });
        },
        exportToReport: function () {
            this.$http({
                url: `/report/overview`,
                method: "GET",
                params: {
                    created_at__gte: this.filterStartDate,
                    created_at__lt: this.filterEndDate,
                    ordering: this.ordering,
                },
                responseType: "blob", // important
            }).then((response) => {
                let filename = `consolidated_report_2020.xlsx`;
                FileSaver.saveAs(new Blob([response.data]), filename);
            });
        },
        exportToReport2021: function () {
            this.$http({
                url: `/report/overview-2021`,
                method: "GET",
                params: {
                    created_at__gte: this.filterStartDate,
                    created_at__lt: this.filterEndDate,
                    ordering: this.ordering,
                },
                responseType: "blob", // important
            }).then((response) => {
                let filename = `consolidated_report_2021.xlsx`;
                FileSaver.saveAs(new Blob([response.data]), filename);
            });
        },
        exportToReport2022: function () {
            this.$http({
                url: `/report/overview-2022`,
                method: "GET",
                params: {
                    created_at__gte: this.filterStartDate,
                    created_at__lt: this.filterEndDate,
                    ordering: this.ordering,
                },
                responseType: "blob", // important
            }).then((response) => {
                let filename = `consolidated_report_2022.xlsx`;
                FileSaver.saveAs(new Blob([response.data]), filename);
            });
        },
        exportToReport2023: function () {
            this.$http({
                url: `/report/overview-2023`,
                method: "GET",
                params: {
                    created_at__gte: this.filterStartDate,
                    created_at__lt: this.filterEndDate,
                    ordering: this.ordering,
                },
                responseType: "blob", // important
            }).then((response) => {
                let filename = `consolidated_report_2023.xlsx`;
                FileSaver.saveAs(new Blob([response.data]), filename);
            });
        },
        exportToExcel: function () {
            this.$http({
                url: `/reports`,
                method: "GET",
                params: {
                    created_at__gte: this.filterStartDate,
                    created_at__lt: this.filterEndDate,
                    ordering: this.ordering,
                },
                responseType: "blob", // important
            }).then((response) => {
                let filename = `report.xlsx`;
                FileSaver.saveAs(new Blob([response.data]), filename);
            });
        },
        refreshListOfItems: function () {
            this.getListOfItems().then((data) => {
                this.items = data.items;
                this.totalItems = data.total;
                this.loading = false;
            });

            this.getStatsOfSatisfaction().then((data) => {
                this.stats.satisfaction.data = data.data;
                this.stats.satisfaction.labels = data.labels;
            });

            this.getStatsOfMonthlyAverage().then((data) => {
                this.stats.monthly.data = data.score;
                this.stats.monthly.labels = data.labels;

                this.stats.total.data = data.total;
                this.stats.total.labels = data.labels;
            });
        },
    },
};
</script>
